/**
 * Counts the number of decimal places of a given number
 * @example
 * ```js
 * countDecimalPlaces(5.32) => 2
 * countDecimalPlaces(4) => 1
 * ```
 */
export const countDecimalPlaces = (num: number) => {
  // Convert to String
  const numStr = String(num);
  // String Contains Decimal
  if (numStr.includes(".")) {
    return numStr.split(".")[1].length;
  }
  // String Does Not Contain Decimal
  return 0;
};
